import {
  ApiResponse,
  ListResponse,
  Params,
  Department,
  DepartmentFormValues,
  Job,
  JobFormValues,
  JobSubmission,
  JobSubmissionsParams,
} from "../types";
import api from "./api";
import { API_ENDPOINTS } from "./endpoints";

const jobService = {
  // Job APIs
  async getJobList(params: Params): Promise<ListResponse<Job>> {
    try {
      const response = await api.get(API_ENDPOINTS.JOBS.LIST, {
        params,
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async getJobById(id: number): Promise<Job> {
    try {
      const response = await api.get(API_ENDPOINTS.JOBS.GET_BY_ID(id));
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createJob(body: JobFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.JOBS.CREATE, body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateJob(id: number, body: JobFormValues): Promise<void> {
    try {
      await api.patch(API_ENDPOINTS.JOBS.UPDATE(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async deleteJob(id: number): Promise<void> {
    try {
      await api.delete(API_ENDPOINTS.JOBS.DELETE(id));
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  // Department APIs
  async getDepartmentList(params: Params): Promise<ListResponse<Department>> {
    try {
      const response = await api.get(API_ENDPOINTS.DEPARTMENTS.LIST, {
        params,
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createDepartment(body: DepartmentFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.DEPARTMENTS.CREATE, body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateDepartment(
    id: number,
    body: DepartmentFormValues
  ): Promise<Department> {
    try {
      const response = await api.patch<ApiResponse<Department>>(
        API_ENDPOINTS.DEPARTMENTS.UPDATE(id),
        body
      );
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async deleteDepartment(id: number): Promise<void> {
    try {
      await api.delete(API_ENDPOINTS.DEPARTMENTS.DELETE(id));
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  // Job Submission APIs
  async getJobSubmissionList(params: JobSubmissionsParams): Promise<ListResponse<JobSubmission>> {
    try {
      const response = await api.get(API_ENDPOINTS.JOB_SUBMISSIONS.LIST, { params });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async getJobSubmissionCVById(id: number): Promise<string> {
    try {
      const response = await api.get(API_ENDPOINTS.JOB_SUBMISSIONS.GET_CV_BY_ID(id));
      return response.data.data.presignedUrl;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  }
};

export default jobService;
